// extracted by mini-css-extract-plugin
export default {"sidenav-footer-alignment":"styles_sidenav-footer-alignment__GVgw6","logo-image":"styles_logo-image__9QfSp"};